<template>
  <div class="no-auth">
    <Error
      :reload="true"
      :title="$t('com_error_network')"
      :description="$t('com_error_network_description')"
      :inline="true"
      style="margin:0 auto;"
      :homeClick="
        () => {
          this.$router.push({ name: 'Home' });
        }
      "
    >
      <Icon type="networkerror2" />
    </Error>
  </div>
</template>
<script>
import Error from '@/components/Error';
export default {
  components: {
    Error,
  },
};
</script>
<style lang="less" scoped>
.no-auth {
  margin: 0 auto;
  color: #999;
  text-align: center;
  padding: 0;
}
</style>
